<template>
  <a-date-picker
    :value="innerValue"
    :allow-clear="allowClear"
    :autocomplete="autocomplete"
    :default-value="defaultValue"
    :disabled="disabled"
    picker="month"
    @change="handleChange"
    format="YYYY-MM"
    :placeholder="placeholder"
    :size="size"
    :style="style"
  />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import dayjs from 'dayjs';

export default defineComponent({
  name: 'MonthPicker',
  props: {
    is_range: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    fix_day: {
      type: Number,
      required: false,
      default: () => 1,
    },
    start_offset_day: {
      type: Number,
      required: false,
      default: () => 0,
    },
    end_offset_day: {
      type: Number,
      required: false,
      default: () => 0,
    },
    value_has_time: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    value_is_array: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    // ----------
    value: {
      type: [String, Array],
      required: false,
      default: () => null,
    },
    allowClear: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    autocomplete: {
      type: String,
      required: false,
      default: () => 'off',
    },
    defaultValue: {
      type: String,
      required: false,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    placeholder: {
      type: String,
      required: false,
      default: () => '请选择',
    },
    size: {
      type: String,
      required: false,
      default: () => 'small',
    },
    style: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  emits: ['update:value'],
  setup(props, { emit }) {
    const innerValueIsArray = computed(() => {
      if (props.value_is_array === null || props.value_is_array === undefined) {
        return true;
      } else {
        return props.value_is_array;
      }
    });
    const innerIsRange = computed(() => {
      if (props.is_range === null || props.is_range === undefined) {
        return false;
      } else {
        return props.is_range;
      }
    });
    const innerFixDay = computed(() => {
      if (props.fix_day === null || props.fix_day === undefined) {
        return 1;
      } else {
        return props.fix_day;
      }
    });
    const innerStartOffsetDay = computed(() => {
      if (props.start_offset_day === null || props.start_offset_day === undefined) {
        return 0;
      } else {
        return props.start_offset_day;
      }
    });
    const innerEndOffsetDay = computed(() => {
      if (props.end_offset_day === null || props.end_offset_day === undefined) {
        return 0;
      } else {
        return props.end_offset_day;
      }
    });
    const innerValueHasTime = computed(() => {
      if (props.value_has_time === null || props.value_has_time === undefined) {
        return false;
      } else {
        return props.value_has_time;
      }
    });
    const innerValue = computed(() => {
      if (innerIsRange.value) {
        if (Array.isArray(props.value) && props.value.length == 2) {
          let start_date: any = props.value[0];
          start_date = dayjs(start_date as string);
          start_date = start_date.subtract(innerStartOffsetDay.value, 'day');
          return start_date;
        } else {
          return undefined;
        }
      } else {
        if (props.value) {
          if (typeof props.value == 'string') {
            let date = dayjs(props.value);
            return date;
          } else if (Array.isArray(props.value) && props.value.length > 0) {
            let start_date: any = props.value[0];
            if (start_date) {
              start_date = dayjs(start_date);
              return start_date;
            } else {
              return undefined;
            }
          } else {
            return undefined;
          }
        } else {
          return undefined;
        }
      }
    });
    const handleChange = (value: dayjs.Dayjs) => {
      if (!value) {
        emit('update:value', null);
        return;
      }
      if (innerIsRange.value) {
        let start_date = value
          .startOf('month')
          .startOf('day')
          .add(innerStartOffsetDay.value, 'day');
        let end_date = value.endOf('month').startOf('day').add(innerEndOffsetDay.value, 'day');
        if (innerValueHasTime.value) {
          end_date = end_date.add(1, 'day');
          emit('update:value', [
            start_date.format('YYYY-MM-DD HH:mm:ss'),
            end_date.format('YYYY-MM-DD HH:mm:ss'),
          ]);
        } else {
          emit('update:value', [start_date.format('YYYY-MM-DD'), end_date.format('YYYY-MM-DD')]);
        }
      } else {
        let result = null;
        let date = value.date(innerFixDay.value).startOf('day');
        if (innerValueHasTime.value) {
          result = date.format('YYYY-MM-DD HH:mm:ss');
        } else {
          result = date.format('YYYY-MM-DD');
        }
        if (innerValueIsArray.value) {
          emit('update:value', [result]);
        } else {
          emit('update:value', result);
        }
      }
    };
    return {
      innerValue,
      handleChange,
      innerIsRange,
      innerFixDay,
      innerStartOffsetDay,
      innerEndOffsetDay,
      innerValueHasTime,
    };
  },
  components: {},
});
</script>
